import MagnifyingGlassIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/MagnifyingGlassIconPath";
import styles from "./global-search.module.css";
import trackerHelper from "@coworker/app/src/helpers/tracker";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import { useTranslation } from "@coworker/locales";
import useFixaNavigate from "@coworker/apprestructured/src/shared/wrappers/FixaNavigate/useFixaNavigate";
// This component is used in the MainHeader componentcon
const GlobalSearch = () => {
  const navigate = useFixaNavigate();
  const { t } = useTranslation();
  const handleClick = () => {
    trackerHelper.trackSearchButtonClick();
    navigate("/scanner/global");
  };
  return (
    <div className={styles["global-search"]}>
      <FixaButton
        aria-label={t("searchBasicString")}
        type="tertiary"
        inverseTheme
        onClick={handleClick}
        iconOnly
        ssrIcon={MagnifyingGlassIconPath}
      />
    </div>
  );
};

export default GlobalSearch;
